import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const getBundleSummaryRequest = createAction("".concat(stateName, "/getBundleSummaryRequest"));
export const getInstantBundleOrderReviewRequest = createAction("".concat(stateName, "/getInstantBundleSummaryOrderReviewRequest"));
export const getBundleSummaryFailure = createAction("".concat(stateName, "/getBundleSummaryFailure"));